import { Injectable } from "@angular/core";
// import { User } from "../../../app/pages/home/user-management/model/user";
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
// import { State } from "../../../app/pages/home/master/model/state";
// import { District } from "../../../app/pages/home/master/model/district";
// import { Circle } from "../../../app/pages/home/master/model/circle";
import { Router } from "@angular/router";
import Swal from 'sweetalert2';
@Injectable({providedIn:'root'})
export class PagesService{
    userManagementServiceApiUrl: string = environment.serviceApiUrl;

    public user:any ={};
    public states = new Array<any>();
    public districts = new Array<any>();
    public circles = new Array<any>();

    constructor(private http: HttpClient,private _router: Router) {
        this.user = JSON.parse(sessionStorage.getItem('currentUser'));
        
    }
    public getUser(){
        return this.user?.userDetails;
    }
    public getUserId(){
        return JSON.parse(sessionStorage.getItem('currentUser'));
        return this.user?.id;
    }

    public getUserLevel() {
        return this.user?.userDetails[0]?.userLevel
    }

    public getUserLevelBasedIds() {
        let userLevelBasedIds = []
        switch (this.user?.userDetails[0]?.userLevel) {
            case 'HO':
                userLevelBasedIds = this.user.userDetails[0].stateId.split(',')
                break;
            case 'STATE':
                userLevelBasedIds = this.user.userDetails[0].stateId.split(',')
                break;
            case 'CIRCLE':
                userLevelBasedIds = this.user.userDetails[0].circleId.split(',')
                break;
            case 'DISTRICT':
                userLevelBasedIds = this.user.userDetails[0].districtId.split(',')
                break;
            case 'CLINIC':
                userLevelBasedIds = this.user.userDetails[0].clinicId.split(',')
                break;
        }
        userLevelBasedIds = userLevelBasedIds.map(id => Number(id) )
        return userLevelBasedIds
    }

    public getUserRoles() {
        let userRoles = []
        this.user.userDetails.forEach(userDetail => {
            userDetail.userGroups[0].userRoles.forEach(userRole => {
                userRoles.push(userRole.roleName)
            })
        })
        let userRoleFlags = {
            create: false, approve: false, modify: false, print: false, view: false, dashboard: false, invoiceOverride: false, reject: false
        }
        userRoleFlags.create = userRoles.includes('Create')
        userRoleFlags.approve = userRoles.includes('Approve')
        userRoleFlags.modify = userRoles.includes('Modify')
        userRoleFlags.print = userRoles.includes('Print')
        userRoleFlags.view = userRoles.includes('View')
        userRoleFlags.dashboard = userRoles.includes('Dashboard')
        userRoleFlags.invoiceOverride = userRoles.includes('Invoice Override')
        userRoleFlags.reject = userRoles.includes('Reject')
        return userRoleFlags;
    }
    public getMenuMappingPriority(userDetail?:any){
        //
        let user =(userDetail==undefined?this.getUser():userDetail);
        let minMasterUserGroupPriority =user?.sort(function (a,b) {
            // console.log("sorted value  a & b", a , b)
          return a.userGroupMasterPriority - b.userGroupMasterPriority || a.userGroupPriority - b.userGroupPriority
        })
        // console.log("menu mapping priority id", minMasterUserGroupPriority)
        return minMasterUserGroupPriority;
    }
    public getMenuMappingPriorityGroupId(){
        // 
        let minMasterUserGroupPriority = this.getMenuMappingPriority();
        if(minMasterUserGroupPriority==undefined){
            minMasterUserGroupPriority=[]
        }
        let userGroupId = undefined;
        if(minMasterUserGroupPriority?.length>0){
            if(minMasterUserGroupPriority[0] !=undefined){
                if(minMasterUserGroupPriority[0].userGroupId !=undefined && minMasterUserGroupPriority[0].userGroupId>0 ){
                    userGroupId = minMasterUserGroupPriority[0].userGroupId;
                }else{
                    // this.getMenuMappingPriorityGroupId()
                    // this.redirectToLogin();
                }
            }else{
                // this.getMenuMappingPriorityGroupId()
                // this.redirectToLogin();
            }
        }else{
            // this.getMenuMappingPriorityGroupId()
            // this.redirectToLogin();
        }
        // console.log("menu mapping priority id", minMasterUserGroupPriority[0].userGroupId)
        // console.log("========================== USer : ",this.getUser());
        // return this.getUser();
        return minMasterUserGroupPriority[0]?.userGroupId;
        // return 1;
        // if(this.user.userDetails[0].userLevel == 'STATE'){
        //     return 1
        // }
        // else{
        //     return 2
        // }

    }
    public redirectToLogin(){
        this._router.navigate(['/auth/login']);
        sessionStorage.removeItem('currentUser');
        Swal.fire('', 'User Group not assigned! Please contact administrator!!!', 'error')
    }
    public fetchAllCircleByStateId(stateId: number) {
        // return this.http.get<Array<any>>(this.userManagementServiceApiUrl + 'circle/state-id/'+stateId)
    }

    public fetchStates():Array<any> {
        this.getUser();
        let statesToReturn = new Array<any>();
        // this.http.get<Array<any>>(this.userManagementServiceApiUrl + 'state/all').subscribe((x)=>{
        //     this.states = x;
        //     this.user.userDetails.forEach((userDetail,i)=>{
        //         this.states.forEach((state,j)=>{
        //             if(userDetail.stateId==+state.id){
        //                 let districts = new Array<any>();
        //                 state.districts.forEach((d,i)=>{
        //                     if(userDetail.userLevel=='circle' || userDetail.userLevel=='district' || userDetail.userLevel=='clinic' ){
        //                         if(userDetail.userLevel=='circle' ){
        //                             if(d.circleId ==userDetail.circleId){
        //                                 state.circleIdToShow = userDetail.circleId;
        //                                 // state.userGroup = userDetail.
        //                                 districts.push(d); 
        //                             }
        //                         }else{
        //                             if(d.id ==userDetail.districtId){
                                        
        //                                 state.districtIdToShow = d.id;
        //                                 districts.push(d); 
        //                             }
        //                         }                  
        //                       } 
        //                       if(state.districts.length -1 == i ){
        //                         districts.length > 0 ? state.districts = districts:'';
        //                       }
        //                   });
        //                   state.userLevel = userDetail.userLevel;
        //                   statesToReturn.push(state);
        //                 // 
        //             }
        //             if((this.user.userDetails.length-1 ==i) && (this.states.length -1 ==j)){
        //                 if(statesToReturn.length==0){
        //                    statesToReturn =  this.states; 
        //                 }                        
        //             }        
        //         })
        //     });
        // });
       
       return statesToReturn;
    }
    public fetchDistricts(districts:Array<any>):Array<any> {
        this.getUser();
        let districtToReturn = new Array<any>();
        
            this.user.userDetails.forEach((userDetail,i)=>{
                if(userDetail.userLevel=='district' || userDetail.userLevel=='clinic' ){
                    districts.forEach((district,j)=>{
                        if(userDetail.districtId==+district.id){
                            districtToReturn.push(district);
                        }      
                    });
                }else if(userDetail.userLevel=='circle'){
                    districts.forEach((district,j)=>{
                        if(userDetail.circleId==+district.circleId){
                            districtToReturn.push(district);
                        }      
                    });
                }
                else if(userDetail.userLevel=='state'){
                    districtToReturn = districts;
                }
             
            });
    
       return districtToReturn;
    }

    getAllUserGroupMenuMappingByGroupId(id){
      return this.http.get<Array<any>>(this.userManagementServiceApiUrl+"qubes-user-group-menu-mapping/group-id/"+id);
    } 
    userLogOut(userName){
              return this.http.get(this.userManagementServiceApiUrl + "qubes-user/logout?userName="+userName)
    }
    refreshHandle(userName,userLoginDetailId){
        return this.http.get(this.userManagementServiceApiUrl + "qubes-user/againLogin?userName="+userName+"&userLoginDetailId="+userLoginDetailId)
    }
    // getAllUserGroupRoleMappingByGroupId(id){
    //     return this.http.get<Array<any>>(this.userManagementServiceApiUrl+"qubes-user-group-role-mapping/group-id/"+id);
    // }

    checkUserLogout(userLoginDetailId){
        return this.http.get(this.userManagementServiceApiUrl + 'qubes-user/checkLogout?userLoginDetailId='+userLoginDetailId);
    }
    getNotification(userId){
        return this.http.get(this.userManagementServiceApiUrl + 'notificationview/findByUserId?userId='+userId);
    }
    checkUserActivity(userId){
        return this.http.get(this.userManagementServiceApiUrl + 'qubes-user/check-user-session?userId='+userId);   
    }
    getVersionInfo(){
        return this.http.get<Array<any>>(this.userManagementServiceApiUrl+"mobileVersion/all");
    }
}